import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSyncAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
// import { Container, Row, Col } from "reactstrap";
import { Select, Tooltip} from 'antd';
import 'antd/dist/antd.css';
import { InfoCircleOutlined, CloudDownloadOutlined } from '@ant-design/icons';
import QMSErrorHandle from '../../../auxil/QMSErrorHandle';
import { axiosInstanceQMS } from "../../../../utils/axiosConfig";
import saveAs from 'file-saver/src/FileSaver';

const { Option } = Select;

export class FileDownloadFromCell extends React.Component{

  constructor(props){
    super(props);
    this.sourceFileDW = React.createRef();

  }

  errorObject = {
    err: false, 
    errCode: null, 
    errType: null, 
    errMsg: null, 
    display : false
}

printError(newError){
    this.errorObject = newError;
    this.forceUpdate();
    setTimeout(() => { 
        this.errorObject = {
            err: false, 
            errCode: null, 
            errType: null, 
            errMsg: null, 
            display : false
        }
    },
    1000);
}

  /** Download Source file */
  downloadSourceFile(linkData){

    if(linkData.s3Bucket !== undefined && linkData.s3Bucket != null && linkData.s3Bucket != '' 
      && linkData.s3Key  !== undefined && linkData.s3Key != null && linkData.s3Key != '' 
      && this.props.fileDownloadPermit){

        let s3Bucket = linkData.s3Bucket;
        let s3key = linkData.s3Key;
        let docId = linkData.docId;
        axiosInstanceQMS.get('/api/callExternal/downloadSourceFile', 
        {
            params : {
                bucket : s3Bucket,
                s3Key : s3key
                // bucket : 'mdo-ngeneric-uat-converted',
                // s3Key : '000b1cb1-58dd-4a8e-a369-c2a8fd1f3c81.pdf'
            },
            responseType : 'blob'
        })
        .then(response => {
            if (response["data"]["error"]) {
                console.error("ERROR :", response["data"]["errorMessage"]);
                this.printError({
                    display: true,
                    err: true,
                    errCode: '500',
                    errType: '',
                    errMsg: 'Error occured'
                });
                return;
            } else {
               // console.log(response);
               // console.log('file',response);
               // console.log('headers',response);
                //console.log('content-type',response[]);
                console.log(typeof response["data"]);

                const blob = new Blob([response["data"]], {type: response["headers"]["content-type"]});
                saveAs(blob, s3key);

                // const url = URL.createObjectURL(blob);
                // var aNode = this.sourceFileDW.current;
                // aNode.href = url;
                // aNode.click();
                // URL.revokeObjectURL(url);
                return true;
            }

        }).catch(error => {
            console.error("ERROR :", error);
            this.printError({
                display: true,
                err: true,
                errCode: '500',
                errType: '',
                errMsg: 'Document Not Available'
            });
        });
    } else {
        console.error("ERROR : S3 data not set in link");
        this.printError({
            display: true,
            err: true,
            errCode: '500',
            errType: '',
            errMsg: 'Error occured'
        });
    }
  }
  
  render(){

    let colVlaue = this.props.data;
    let meta = {
      s3Key : colVlaue.s3Key,
      s3Bucket : colVlaue.s3Bucket,
      docId : colVlaue.docId,
    }
    let allowClick = ( meta.s3Key.trim() !== "" && meta.s3Bucket.trim() !== "" 
    && meta.docId.trim() !== "" && this.props.fileDownloadPermit);
    let returnComponent = <div>
                            <QMSErrorHandle errordetails={this.errorObject} />
                            <div style={{ 
                              height : "50px",
                              paddingTop : "25px"
                              }}>
                                {this.props.value}
                            </div>
                            <div style={{ 
                                height : "15px",
                                textAlign : "right"
                              }}>
                              <span style={{ 
                                  fontSize : "14px",
                                  color : "#007bff"
                                }}
                                
                              >
                                {(
                                  this.props.fileDownloadPermit 
                                  && colVlaue.value !== "N/A")?
                                (
                                  <CloudDownloadOutlined onClick={() => {
                                    if(allowClick){
                                      this.downloadSourceFile(meta);
                                    }
                                  }}
                                  className={(allowClick)?"cursorPointer":"cursorDisabled"}
                                />):""}
                              </span>
                            </div>
                            {/* <a className="cursorDefault" id={'SFD_'+colVlaue.docId} ref={this.sourceFileDW} download={'sourceFile_'+ colVlaue.docId} ></a> */}
                          </div>;
    return returnComponent;
  }
  
}

export function FileNameContainer(props){
  let returnComponent = <div>
                          <div style={{ 
                            height : "50px",
                            paddingTop : "25px"
                            }}
                            className="contentValue"
                            >
                              {props.value}
                          </div>
                          <div style={{ 
                              height : "15px",
                              textAlign : "right"
                            }}>
                              <Tooltip title={"Uploaded from : "+props.tooltip}>
                                <span style={{ 
                                    fontSize : "14px",
                                    color : "#007bff"
                                  }}
                                  className="cursorPointer"
                                >
                                  <InfoCircleOutlined />
                                </span>
                              </Tooltip>
                          </div>
                        </div>;  
  return returnComponent;
}

export function PopupContainer(props){
  let colVlaue = props.popupData;
  let returnComponent = <div>
                          <div style={{ 
                            height : "50px",
                            paddingTop : "25px"
                            }}>
                              {props.value}
                          </div>
                          <div style={{ 
                              height : "15px",
                              textAlign : "right"
                            }}>
                            <span style={{ 
                                fontSize : "14px",
                                color : "#007bff"
                              }}
                              className="cursorPointer"
                              onClick={() => {
                                props.openModal(colVlaue.data);
                              }}
                            >
                              <InfoCircleOutlined />
                            </span>
                          </div>
                        </div>;  
  return returnComponent;
}

export function IconSwitcher(props){
    var iconValue = props.value;
    if(iconValue.toLowerCase() == "yes"){
        return <FontAwesomeIcon icon={faCheck} className="text-green"/>;
    }else if(iconValue.toLowerCase() == "no"){
        return <FontAwesomeIcon icon={faTimes} className="text-red"/>;
    }else if(iconValue.toLowerCase() == "sync"){
        return <FontAwesomeIcon icon={faSyncAlt} className="text-yellow"/>;
    }else {
        return "N/A";
    }
}
  
export const editOptions = {
    edit:"Edit",
    cancel:"Cancel"
}
/**
 * CustDropdown independent dropdown component for cells
 * special behavior :  values must be mutually exclusive within a chain id
 */
export class CustDropdown extends React.Component{
    constructor(props){
      super(props);
      this.state = {
      }
    }

    render(){
      //cell info
      let cellInfo = this.props.cellInfo; 

      if(cellInfo.mydocs.value != 'N/A'){
        //reports mapped to chain id
        var reports = cellInfo.reports;
        //list containing reportwise dropdowns to be appended
        var selectList = [];
        //loop to generate drpdowns
        for(let a = 0 ; a<reports.length; a++){
          //report list mapped to user
          let uniqueReports = [];
          // alert(JSON.stringify(this.props.mappedReports))
          const mappedReports = [].concat(this.props.mappedReports);
          //alert(JSON.stringify(mappedReports))
          mappedReports.forEach( hotel => {
            if(hotel["hotelCode"] === cellInfo.marshaCode){
              hotel["hotelReports"].forEach( hotelreports => {
                // alert("Util >> "+hotelreports.name+ " : "+this.props.solution)
                if(hotelreports.name === this.props.solution){
                  hotelreports["reportsList"].forEach( report => {
                    uniqueReports.push({
                        reportId : report["reportId"],
                        typeId : report["reportName"],
                        name : report["reportName"],
                    })
                  })
                }
              });

              // let keyList = Object.keys(hotel["hotelReports"]);
              // keyList.forEach(key => {
              //   hotel["hotelReports"][key].forEach( hotelReports => {
              //     uniqueReports.push({
              //         reportId : hotelReports["reportId"],
              //         typeId : hotelReports["reportName"],
              //         name : hotelReports["reportName"],
              //     })
              //   });
              // });
            }
          });
          //!!!! BAD LOOP!!!! try to optimize here
          //make report list for dropdown mutually exclusive
          for(let x=0 ; x<reports.length; x++){
            let reportExists = false;
            for(let y=0 ; y<uniqueReports.length ; y++){
              //if mapped report list contains chain id reports remove except docId report
              if(uniqueReports[y]["typeId"] == reports[a]["typeId"]){
                reportExists = true;
              }else if((uniqueReports[y]["typeId"] == reports[x]["typeId"]) && 
              (uniqueReports[y]["typeId"] != reports[a]["typeId"]) ){
                uniqueReports.splice(y,1);
              }
            }
            if(!reportExists){
              uniqueReports.push( { reportId : 0, typeId : reports[a]["typeId"] , name : reports[a]["name"] } );
            }
          }
          //Try to optimize above
    
          //selected value
          let selected = "";
          //
          let nonCurrentSelects = [];
          //
          for(let x = 0; x<this.props.editedDropdown.length; x++){
            if(this.props.editedDropdown[x]["ddId"] == reports[a]["id"]){
              selected = this.props.editedDropdown[x]["ddVal"];
            }else if(this.props.editedDropdown[x]["ddCid"] == reports[a]["chainId"]){ 
              nonCurrentSelects.push(this.props.editedDropdown[x]["ddVal"]);
            }
          }
          
          let optList = [];
          for(let x=0 ; x<uniqueReports.length; x++){
            let disabled = false;
            for(let y = 0 ; y<nonCurrentSelects.length; y++){
              if(nonCurrentSelects[y] == uniqueReports[x]["typeId"]){
                disabled = true;
              }
            }
            let option = <Option key={uniqueReports[x]["reportId"]} docId={reports[a]["id"]}
                      index={this.props.index} value={uniqueReports[x]["typeId"]} disabled = {disabled}>
              {uniqueReports[x]["name"]}</Option>;
            optList.push(option);
          }

          //select element for report (docid)
          let select = <Select 
                          style={{ width: '100%' }}
                          onChange={ ( value, optData) => {
                              console.log(optData, value)
                              this.props.dropdownChange(optData.props.docId, value, optData.props.index);
                          }}
                          
                          value={selected}  
                          id={reports[a]["id"]}
                          key={reports[a]["id"]}  
                          //disabled={!this.props.isEditable}
                          disabled
                          //class={(!this.props.isEditable)?"customInputDisabled":"customInputActive"}
                        >
                          {optList}
                        </Select>;
    
          selectList.push(select);
        }

        if(selectList.length >0 && selectList.length < 4){
          return <div style={{overflowX : "scroll", overflowY : "auto"}}>{selectList}</div>; 
        }else if (selectList.length >= 4) {
          return <div style={{overflowX : "scroll", overflowY : "auto", height : "150px"}}>{selectList}</div>;
        } else{
          return <div></div>
        }
      } else if(cellInfo.mydocs.value == 'N/A'){
          return <div>N/A</div>
      }
      
    }   
}